import axios from 'axios';
import { io } from 'socket.io-client';

const API_BASE   = process.env.REACT_APP_SERVER_BASE_URL || 'http://localhost:3001';
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:3001';

let socket = null;

// ── REST helpers ─────────────────────────────────────────────────────────────
const authHeader = () => {
    const admin = JSON.parse(localStorage.getItem('admin') || '{}');
    return { Authorization: `Bearer ${admin.auth_token || ''}` };
};

export const chatApi = {
    getConversations: (params = {}) =>
        axios.get(`${API_BASE}/admin/chat/conversations`, {
            headers: authHeader(), params
        }),

    getMessages: (convId, params = {}) =>
        axios.get(`${API_BASE}/admin/chat/conversations/${convId}/messages`, {
            headers: authHeader(), params
        }),

    assignAgent: (convId, agentId) =>
        axios.post(`${API_BASE}/admin/chat/conversations/${convId}/assign`,
            { agentId }, { headers: authHeader() }),

    closeConversation: (convId) =>
        axios.post(`${API_BASE}/admin/chat/conversations/${convId}/close`,
            {}, { headers: authHeader() }),

    sendMessage: (convId, payload) =>
        axios.post(`${API_BASE}/admin/chat/conversations/${convId}/send`,
            payload, { headers: authHeader() }),

    getAgents: () =>
        axios.get(`${API_BASE}/admin/chat/agents`, { headers: authHeader() }),

    getUploadUrl: (payload) =>
        axios.post(`${API_BASE}/admin/chat/upload-url`,
            payload, { headers: authHeader() }),
};

// ── Socket.IO connection ──────────────────────────────────────────────────────
export const connectChatSocket = () => {
    if (socket && socket.connected) return socket;

    const admin = JSON.parse(localStorage.getItem('admin') || '{}');
    const token = admin.auth_token;
    if (!token) return null;

    socket = io(`${SOCKET_URL}/chat`, {
        auth: { token, type: 'admin' },
        transports: ['websocket', 'polling'],
        reconnectionAttempts: 5,
        reconnectionDelay: 2000,
    });

    socket.on('connect', () => console.log('[Chat] Socket connected:', socket.id));
    socket.on('connect_error', (err) => console.error('[Chat] Socket error:', err.message));
    socket.on('disconnect', (reason) => console.log('[Chat] Socket disconnected:', reason));

    return socket;
};

export const disconnectChatSocket = () => {
    if (socket) { socket.disconnect(); socket = null; }
};

export const getChatSocket = () => socket;

// ── Upload media to S3 via pre-signed URL ────────────────────────────────────
export const uploadMediaToS3 = async (file, mediaType = 'image') => {
    // 1. Get pre-signed URL from our API
    const { data } = await chatApi.getUploadUrl({
        fileName:    file.name,
        contentType: file.type,
        mediaType
    });
    if (!data || data.status !== 1) throw new Error('Failed to get upload URL');

    const { uploadUrl, publicUrl } = data.data;

    // 2. PUT directly to S3
    const response = await fetch(uploadUrl, {
        method: 'PUT',
        body: file,
        headers: {
            'Content-Type': file.type
        }
    });

    if (!response.ok) {
        throw new Error(`Upload failed with status ${response.status}`);
    }

    return publicUrl;
};
